import './scripts/common';
import './scripts/common-nav';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as searchReset from './scripts/search-reset';
searchReset.init();

import * as scrollToTop from './scripts/scroll-to-top';
scrollToTop.init();

